import React from "react";

function Banner({ details }) {
  return (
    <div className="w-full flex flex-col items-center space-y-4">
      <div className="w-full flex flex-col items-center space-y-4 max-w-3xl mx-auto py-4">
        {details?.image?.url ? (
          <div
            style={{
              boxShadow:
                "0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -2px rgba(0, 0, 0, 0.10), 0px 0px 16px 0px rgba(0, 0, 0, 0.05)",
            }}
            className="w-[120px] h-[120px] rounded-lg bg-white flex flex-row items-center justify-center"
          >
            <img
              src={details?.image?.url}
              alt=""
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        ) : (
          <div className="w-[120px] h-[120px] rounded-lg shadow-inner bg-primary-neutral-50 flex flex-row items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M25.3333 9.33335V13.32C25.3333 13.32 22.68 13.3334 22.6667 13.32V9.33335H18.6667C18.6667 9.33335 18.68 6.68002 18.6667 6.66669H22.6667V2.66669H25.3333V6.66669H29.3333V9.33335H25.3333ZM21.3333 14.6667V10.6667H17.3333V6.66669H6.66667C5.2 6.66669 4 7.86669 4 9.33335V25.3334C4 26.8 5.2 28 6.66667 28H22.6667C24.1333 28 25.3333 26.8 25.3333 25.3334V14.6667H21.3333ZM6.66667 25.3334L10.6667 20L13.3333 24L17.3333 18.6667L22.6667 25.3334H6.66667Z"
                fill="#CFCDC9"
              />
            </svg>
          </div>
        )}
        <h1 className="text-white font-poppins text-[32px] font-medium">
          {details?.name}
        </h1>
        <h2 className="text-white opacity-80 font-poppins text-sm font-medium">
          {details?.industry}
        </h2>
        <p className="text-white opacity-70 font-poppins text-sm font-light">
          {details?.description}
        </p>
      </div>
      <div className="px-4 flex flex-col lg:flex-row items-center space-y-1.5 lg:space-y-0 lg:items-stretch lg:divide-x-2 lg:divide-primary-neutral-50 justify-center">
        {[
          {
            svg: (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M0.5 8C0.5 5.87827 1.34285 3.84344 2.84315 2.34315C4.34344 0.842855 6.37827 0 8.5 0C10.6217 0 12.6566 0.842855 14.1569 2.34315C15.6571 3.84344 16.5 5.87827 16.5 8C16.5 10.1217 15.6571 12.1566 14.1569 13.6569C12.6566 15.1571 10.6217 16 8.5 16C6.37827 16 4.34344 15.1571 2.84315 13.6569C1.34285 12.1566 0.5 10.1217 0.5 8ZM8 1.077C7.33 1.281 6.665 1.897 6.113 2.932C5.97 3.2 5.837 3.492 5.718 3.804C6.423 3.961 7.19 4.061 8 4.091V1.077ZM4.749 3.539C4.891 3.155 5.053 2.795 5.23 2.461C5.40291 2.13406 5.60259 1.82199 5.827 1.528C4.97567 1.8808 4.20225 2.398 3.551 3.05C3.913 3.234 4.314 3.398 4.749 3.539ZM4.009 7.5C4.045 6.43 4.197 5.413 4.445 4.492C3.9037 4.31889 3.37976 4.09559 2.88 3.825C2.08354 4.89435 1.61082 6.16987 1.518 7.5H4.008H4.009ZM5.409 4.759C5.17325 5.65477 5.03907 6.57422 5.009 7.5H8V5.091C7.09 5.061 6.217 4.946 5.409 4.759ZM9 5.09V7.5H11.99C11.9603 6.57426 11.8264 5.6548 11.591 4.759C10.783 4.946 9.91 5.059 9 5.09ZM5.01 8.5C5.045 9.487 5.186 10.414 5.409 11.241C6.26006 11.0479 7.12772 10.937 8 10.91V8.5H5.01ZM9 8.5V10.909C9.91 10.939 10.783 11.054 11.591 11.241C11.814 10.414 11.955 9.487 11.991 8.5H9ZM5.718 12.196C5.838 12.508 5.97 12.8 6.113 13.068C6.665 14.103 7.331 14.718 8 14.923V11.91C7.19 11.94 6.423 12.039 5.718 12.196ZM5.828 14.472C5.60323 14.1781 5.40321 13.866 5.23 13.539C5.04582 13.1904 4.88513 12.83 4.749 12.46C4.33763 12.5922 3.9371 12.756 3.551 12.95C4.20225 13.602 4.97667 14.1192 5.828 14.472ZM4.445 11.508C4.18538 10.5252 4.03876 9.51603 4.008 8.5H1.518C1.61077 9.83014 2.0835 11.1057 2.88 12.175C3.35 11.917 3.875 11.693 4.445 11.508ZM11.173 14.472C12.0239 14.1194 12.797 13.6026 13.448 12.951C13.0622 12.7571 12.662 12.5932 12.251 12.461C12.1148 12.8306 11.9541 13.1908 11.77 13.539C11.5971 13.866 11.3975 14.178 11.173 14.472ZM9 11.909V14.923C9.67 14.719 10.335 14.103 10.887 13.068C11.03 12.8 11.163 12.508 11.282 12.196C10.5316 12.0315 9.76778 11.9347 9 11.909ZM12.555 11.508C13.125 11.693 13.65 11.917 14.12 12.175C14.9165 11.1057 15.3892 9.83014 15.482 8.5H12.992C12.9612 9.51603 12.8146 10.5252 12.555 11.508ZM15.482 7.5C15.3892 6.16986 14.9165 4.89433 14.12 3.825C13.65 4.083 13.125 4.307 12.555 4.492C12.803 5.412 12.955 6.43 12.992 7.5H15.482ZM11.77 2.461C11.947 2.795 12.109 3.155 12.252 3.539C12.6627 3.40675 13.0626 3.24292 13.448 3.049C12.7969 2.39782 12.0238 1.88132 11.173 1.529C11.391 1.812 11.591 2.126 11.77 2.461ZM11.282 3.804C11.1684 3.50549 11.0365 3.21427 10.887 2.932C10.335 1.897 9.67 1.282 9 1.077V4.09C9.81 4.06 10.577 3.961 11.282 3.804Z"
                    fill="#E7E6E5"
                  />
                </svg>
              </>
            ),
            key: "website",
          },
          {
            svg: (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M8 0C5.82667 0 5.55533 0.01 4.702 0.048C3.85 0.088 3.27 0.222 2.76 0.42C2.234 0.624 1.78733 0.898 1.34267 1.34267C0.898 1.78733 0.623333 2.23333 0.42 2.76C0.222 3.27 0.0873333 3.85 0.048 4.702C0.008 5.55533 0 5.82667 0 8C0 10.1733 0.01 10.4447 0.048 11.298C0.088 12.1493 0.222 12.73 0.42 13.24C0.624 13.7653 0.898 14.2127 1.34267 14.6573C1.78733 15.1013 2.23333 15.3767 2.76 15.58C3.27067 15.7773 3.85067 15.9127 4.702 15.952C5.55533 15.992 5.82667 16 8 16C10.1733 16 10.4447 15.99 11.298 15.952C12.1493 15.912 12.73 15.7773 13.24 15.58C13.7653 15.376 14.2127 15.1013 14.6573 14.6573C15.1013 14.2127 15.3767 13.7673 15.58 13.24C15.7773 12.73 15.9127 12.1493 15.952 11.298C15.992 10.4447 16 10.1733 16 8C16 5.82667 15.99 5.55533 15.952 4.702C15.912 3.85067 15.7773 3.26933 15.58 2.76C15.376 2.234 15.1013 1.78733 14.6573 1.34267C14.2127 0.898 13.7673 0.623333 13.24 0.42C12.73 0.222 12.1493 0.0873333 11.298 0.048C10.4447 0.008 10.1733 0 8 0ZM8 1.44C10.1353 1.44 10.39 1.45067 11.2333 1.48733C12.0133 1.524 12.4367 1.65333 12.718 1.764C13.0927 1.90867 13.358 2.082 13.6393 2.36133C13.9187 2.64133 14.092 2.90733 14.2367 3.282C14.346 3.56333 14.4767 3.98667 14.512 4.76667C14.55 5.61067 14.5587 5.864 14.5587 8C14.5587 10.136 14.5487 10.39 14.5093 11.2333C14.4687 12.0133 14.3387 12.4367 14.2287 12.718C14.0793 13.0927 13.9093 13.358 13.6293 13.6393C13.35 13.9187 13.08 14.092 12.7093 14.2367C12.4293 14.346 11.9993 14.4767 11.2193 14.512C10.37 14.55 10.12 14.5587 7.98 14.5587C5.83933 14.5587 5.58933 14.5487 4.74067 14.5093C3.96 14.4687 3.53 14.3387 3.25 14.2287C2.87067 14.0793 2.61 13.9093 2.33067 13.6293C2.05 13.35 1.87067 13.08 1.73067 12.7093C1.62067 12.4293 1.49133 11.9993 1.45067 11.2193C1.42067 10.3793 1.41 10.12 1.41 7.99C1.41 5.85933 1.42067 5.59933 1.45067 4.74933C1.49133 3.96933 1.62067 3.54 1.73067 3.26C1.87067 2.88 2.05 2.62 2.33067 2.33933C2.61 2.06 2.87067 1.88 3.25 1.74067C3.53 1.63 3.95067 1.5 4.73067 1.46C5.58067 1.43 5.83067 1.42 7.97 1.42L8 1.44ZM8 3.892C5.73 3.892 3.892 5.732 3.892 8C3.892 10.27 5.732 12.108 8 12.108C10.27 12.108 12.108 10.268 12.108 8C12.108 5.73 10.268 3.892 8 3.892ZM8 10.6667C6.52667 10.6667 5.33333 9.47333 5.33333 8C5.33333 6.52667 6.52667 5.33333 8 5.33333C9.47333 5.33333 10.6667 6.52667 10.6667 8C10.6667 9.47333 9.47333 10.6667 8 10.6667ZM13.2307 3.73C13.2307 4.26 12.8 4.69 12.2707 4.69C11.7407 4.69 11.3107 4.25933 11.3107 3.73C11.3107 3.20067 11.7413 2.77067 12.2707 2.77067C12.7993 2.77 13.2307 3.20067 13.2307 3.73Z"
                    fill="#E7E6E5"
                  />
                </svg>
              </>
            ),
            key: "instagram",
          },
          {
            svg: (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M14.1313 13.6347H11.762V9.922C11.762 9.03667 11.744 7.89733 10.5273 7.89733C9.292 7.89733 9.10333 8.86067 9.10333 9.85667V13.6347H6.734V6H9.01V7.04067H9.04067C9.35867 6.44067 10.132 5.80733 11.2873 5.80733C13.688 5.80733 14.132 7.38733 14.132 9.444L14.1313 13.6347ZM4.058 4.95533C3.29533 4.95533 2.68267 4.338 2.68267 3.57867C2.68267 2.82 3.296 2.20333 4.058 2.20333C4.818 2.20333 5.434 2.82 5.434 3.57867C5.434 4.338 4.81733 4.95533 4.058 4.95533ZM5.246 13.6347H2.87V6H5.246V13.6347ZM15.3167 0H1.68067C1.028 0 0.5 0.516 0.5 1.15267V14.8473C0.5 15.4847 1.028 16 1.68067 16H15.3147C15.9667 16 16.5 15.4847 16.5 14.8473V1.15267C16.5 0.516 15.9667 0 15.3147 0H15.3167Z"
                    fill="#E7E6E5"
                  />
                </svg>
              </>
            ),
            key: "linkedIn",
          },
        ]?.map((item) => {
          if (details && details[item?.key] !== null)
            return (
              <div className="flex flex-row items-center space-x-4 lg:px-6">
                {item?.svg}
                <p className="text-primary-neutral-200 font-inter text-base font-light break-all">
                  {details[item?.key]}
                </p>
              </div>
            );
        })}
      </div>
    </div>
  );
}

export default Banner;
